var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mensagem.status == 0)?_c('span',[_c('b-button',{staticClass:"float-right ml-2",attrs:{"variant":"success","disabled":_vm.desabilitarEnviar},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarEnviar()}}},[_c('span',[_c('i',{staticClass:"fa fa-paper-plane-o"}),_vm._v(" Enviar ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }